///? Default IMPORTS
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import React, { Component } from "react";

///? Service IMPORTS
import { MissingMedDashboardThunk } from "../../../redux/MissingMedDashboard/action";

///? Component & Styling IMPORTS
import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
import "react-day-picker/lib/style.css";
import { Divider, Input, message, Spin, Table, Button, Tag, Badge } from "antd";
// import ToggleWarehouse from "../../../components/WarehouseToggle/toggleWarehouse";

import { FiSearch } from "react-icons/fi";
import {
  MissingMedDashboardTable,
  MissingMedDashboardWrapper,
  DashboardWrapperBox,
} from "./MissingMedDash.styled";
import DashboardBox from "../../../components/DashboardBox/DashboardBox";
import { Base64func } from "../../../components/Base64Func/Base64func";
import { GrDocumentCsv } from "react-icons/gr";
import Highlighter from "react-highlight-words";
import { warehouseId } from "../../../constants";

///? Constants
message.config({
  maxCount: 1,
});

let disableSubmitBtnVar = false;

export class MissingMedDashboard extends Component {
  state = {
    from: undefined,
    to: undefined,
    loaderSearch: false,
    statLocal: null,
    warehouseId: warehouseId,
    // selectedTags: ["All"],
    isLoaded: false,
    checkerStats: null,
    currentBox: "Missing Medicine",
    missingTableArray: null,
    tableDataLoad: false,
  };

  componentDidMount() {
    window.onbeforeunload = function () {
      if (disableSubmitBtnVar) {
        return "Data will be lost if you leave the page, are you sure?";
      }
    };
    // let { warehouseId, selectedTags } = this.state;
    // if (this.props.userDto) {
    //   if (this.props.userType) {
    //     warehouseId = [0];
    //     selectedTags = ["All"];
    //   } else {
    //     warehouseId = [this.props.userDto.warehouseIdList[0]];
    //     selectedTags = this.props.warehouseList[warehouseId]["warehouseName"];
    //   }
    // }

    this.setState(
      {
        // warehouseId,
        // selectedTags,
        isLoaded: true,
        from: this.getStartDate(new Date()),
        to: new Date(),
      },
      () => {
        // this.getCheckerData();
      }
    );
  }

  getStartDate = (date) => {
    date.setDate(date.getDate() - 2);
    return date;
  };

  // handleWareHouseChange = (data) => {
  //   this.setState(
  //     {
  //       selectedTags: data.selectedTags,
  //       warehouseId: [data.warehouseId],
  //       isLoaded: false,
  //     },
  //     () => {
  //       this.getCheckerData();
  //     }
  //   );
  // };

  handleFromChange = (from) => {
    this.setState({ from });
  };
  handleToChange = (to) => {
    this.setState({ to }, this.showFromMonth);
  };
  showFromMonth = () => {
    const { from, to } = this.state;
    if (!from) {
      return;
    }
    if (moment(to).diff(moment(from), "months") < 2) {
      this.to.getDayPicker().showMonth(from);
    }
  };
  DateFormatter = (param) => {
    let result =
      this.state[param].getFullYear() +
      "-" +
      (this.state[param].getMonth() + 1) +
      "-" +
      this.state[param].getDate();
    return result;
  };
  getCheckerData = () => {
    disableSubmitBtnVar = true;
    message.loading("Loading Data...Please Wait!", 0);
    this.setState({ isLoaded: false });
    let { from, to } = this.state;
    let { userDto } = this.props;
    // let { warehouseId } = this.state;
    if (from && to) {
      this.setState({ loaderSearch: true, tableDataLoad: true });
      let fromRefined = this.DateFormatter("from");
      let toRefined = this.DateFormatter("to");
      let propsData = {
        access_token: this.props.access_token,
        fromDate: fromRefined + " 00:00:01",
        toDate: toRefined + " 23:59:59",
        history: this.props.history,
        isMissing: this.state.currentBox === "Missing Medicine" ? true : false,
        isExpired: this.state.currentBox === "Expired" ? true : false,
        isDamaged: this.state.currentBox === "Damaged Medicine" ? true : false,
      };

      let data = [warehouseId];

      setTimeout(() => {
        if (!this.state.isLoaded) {
          message.loading(
            "This page is taking longer to load than usual, please wait!",
            0
          );
        }
      }, 5000);

      this.props.MissingMedDashboardThunk(propsData, data).then(() => {
        disableSubmitBtnVar = false;

        message.destroy();
        if (this.props?.stat?.missingMedDashboardError) {
          message.error(
            this.props?.stat?.missingMedDashboardError
              ? this.props?.stat?.missingMedDashboardError
              : "Something went wrong"
          );
          this.setState({
            loaderSearch: false,
            isLoaded: true,
            statLocal: null,
          });
        } else {
          message.success("Data successfully loaded");

          this.setState(
            {
              loaderSearch: false,
              statLocal: this.props?.stat?.missingMedDashboardData,
              isLoaded: true,
            },
            () => {
              let tempArray = [];
              let tableArr = [];

              let { statLocal } = this.state;

              statLocal.stats.map((i) => {
                tempArray.push([
                  {
                    name: "Total Orders",
                    count: i.totalOrders,
                    type: "pick",
                  },
                  {
                    name: "Missing Medicine",
                    count: i.missingMedicine,
                    type: "missingMed",
                  },
                  {
                    name: "Expired",
                    count: i.expired,
                    type: "expired",
                  },
                  {
                    name: "Damaged Medicine",
                    count: i.damagedMedicine,
                    type: "damage",
                  },
                  {
                    name: "Admin Picker Available",
                    count: i.adminPickerAvailable,
                    type: "pick",
                  },
                ]);
              });

              statLocal.dashBoardStats.map((p, o) => {
                let dashTemp = p;
                dashTemp.missingMedicineDetailsList = p.missingMedicineDetailsList.map(
                  (x) => x.active && x.name
                );
                dashTemp.orderBoxMapping =
                  p.orderBoxMapping &&
                  p.orderBoxMapping["active"] &&
                  p.orderBoxMapping["boxNumber"];

                tableArr.push(dashTemp);
              });

              this.setState({
                checkerStats: tempArray,
                missingTableArray: tableArr,
                tableDataLoad: false,
              });
            }
          );
        }
      });
    } else {
      message.warn("Please select a date range");
      this.setState({ isLoaded: true, loaderSearch: false });
    }
  };

  dashboradBoxClick = (value) => {
    this.setState({ currentBox: `${value}` }, () => this.getCheckerData());
  };

  ////? Table search filter
  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({ searchText: selectedKeys[0], searchedColumn: dataIndex });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          // type={dataIndex === "missingMedicineDetailsList" ? "number" : "text"}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(
              e.target.value
                ? dataIndex === "missingMedicineDetailsList"
                  ? [e.target.value.trim()]
                  : [e.target.value]
                : []
            )
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          //  icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <FiSearch style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => {
      return text && this.state.searchedColumn === dataIndex ? (
        dataIndex === "missingMedicineDetailsList" ? (
          <div className="medName">
            <Highlighter
              highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
              searchWords={[this.state.searchText]}
              autoEscape
              textToHighlight={text.toString()}
            />
          </div>
        ) : (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[this.state.searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        )
      ) : dataIndex === "missingMedicineDetailsList" ? (
        text ? (
          text.map((e) => <span className="medName">{e}</span>)
        ) : (
          ""
        )
      ) : (
        text
      );
    },
  });

  // - Ends //

  render() {
    const { from, to } = this.state;
    const modifiers = { start: from, end: to };
    const columns = [
      {
        title: "Order ID",
        dataIndex: "orderId",
        key: "orderId",
        render: (text) => <span>{text}</span>,
        ...this.getColumnSearchProps("orderId"),
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        render: (text) => <span>{text}</span>,
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "Status",
        dataIndex: "availableStatus",
        key: "availableStatus",
        sorter: (a, b) => a.availableStatus - b.availableStatus,
        sortDirections: ["descend", "ascend"],
        render: (text) => {
          return {
            children: (
              <span>
                {text ? (
                  <Badge color="green" className="statusDots" />
                ) : (
                  <Badge color="yellow" className="statusDots" />
                )}
              </span>
            ),
          };
        },
      },
      {
        title: "Checker / Picker",
        dataIndex: "checker",
        key: "checker",
        sorter: (a, b) => a.checker - b.checker,
        sortDirections: ["descend", "ascend"],
        render: (text) => <span>{text ? "Checker" : "Picker"}</span>,
      },
      {
        title: "Medicine Name",
        dataIndex: "missingMedicineDetailsList",
        key: "missingMedicineDetailsList",
        render: (text) =>
          text.map((i, p) => (
            <span className="medName" key={p}>
              {i}
            </span>
          )),
        ...this.getColumnSearchProps("missingMedicineDetailsList"),
      },
      {
        title: "Box Number",
        dataIndex: "orderBoxMapping",
        key: "orderBoxMapping",
        render: (text) => <span>{text}</span>,
        ...this.getColumnSearchProps("orderBoxMapping"),
      },
      {
        title: "Pending Since",
        dataIndex: "pendingSince",
        key: "pendingSince",
        sorter: (a, b) => a.pendingSince - b.pendingSince,
        sortDirections: ["descend", "ascend"],
        render: (text) => (
          <span>
            {" "}
            {text > 12 ? (
              <Tag color="red">{text} Hrs</Tag>
            ) : (
              <Tag color="green">{text} Hrs</Tag>
            )}
          </span>
        ),
      },
    ];
    return (
      <>
        <MissingMedDashboardWrapper>
          <div className="DateSelect">
            <DayPickerInput
              value={from}
              placeholder="From"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { after: to },
                toMonth: to,
                modifiers,
                numberOfMonths: 2,
                onDayClick: () => this.to.getInput().focus(),
              }}
              onDayChange={this.handleFromChange}
            />

            <DayPickerInput
              ref={(el) => (this.to = el)}
              value={to}
              placeholder="To"
              format="DD/MM/YYYY"
              formatDate={formatDate}
              parseDate={parseDate}
              dayPickerProps={{
                selectedDays: [from, { from, to }],
                disabledDays: { before: from },
                modifiers,
                month: from,
                fromMonth: from,
                numberOfMonths: 2,
              }}
              onDayChange={this.handleToChange}
            />
            <button
              className="bbtn"
              onClick={() => {
                this.getCheckerData();
              }}
              // disabled={!this.state.from || !this.state.to}
              disabled={!this.state.isLoaded}
            >
              Search
            </button>
          </div>

          {/* <button
            className="bbtn"
            style={{ width: "max-content" }}
            disabled={!this.state.statLocal}
          >
            Export CSV <GrDocumentCsv />
          </button> */}

          {/* {this.props.userType ? (
            <ToggleWarehouse
              handleWareHouseChange={(data) => this.handleWareHouseChange(data)}
              selectedTags={this.state.selectedTags}
              warehouseId={this.state.warehouseId}
              userDto={this.props.userDto}
              warehouseList={this.props.warehouseList}
              isLoaded={this.state.isLoaded}
            />
          ) : (
            ""
          )} */}
        </MissingMedDashboardWrapper>

        {this.state.statLocal && (
          <Spin spinning={!this.state.isLoaded}>
            <Divider>Missing Medicine Stats</Divider>

            <DashboardWrapperBox>
              {this.state.checkerStats &&
                this.state.checkerStats[0].map((i, p) => (
                  <DashboardBox
                    name={i.name}
                    subName={i.subName}
                    count={i.count}
                    totalCount={i.totalCount}
                    type={i.type}
                    key={p}
                    onClick={this.dashboradBoxClick}
                    activeBox={this.state.currentBox}
                    clickable={
                      i.name !== "Total Orders" &&
                      i.name !== "Admin Picker Available" &&
                      i.name !== "Picked" &&
                      i.name !== "Missing Med"
                        ? true
                        : false
                    }
                  />
                ))}
            </DashboardWrapperBox>

            <Divider style={{ margin: "2.5em  0" }}>
              Missing Medicine Dashboard Stats
            </Divider>

            <MissingMedDashboardTable>
              <Table
                dataSource={this.state.missingTableArray}
                columns={columns}
                pagination={
                  this.state.missingTableArray &&
                  this.state.missingTableArray.length > 10
                    ? true
                    : false
                }
                loading={this.state.tableDataLoad}
                onRow={(record, rowIndex) => {
                  return {
                    onClick: (event) => {
                      message.loading("Loading...", 0);
                      setTimeout(() => {
                        message.destroy();
                        this.props.history.push(
                          `/missingMed/orderId=${Base64func(
                            record.orderId,
                            "encode"
                          )}/warehouseId=${this.state.warehouseId}`
                        );
                      }, 1000);
                    },
                  };
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </MissingMedDashboardTable>
          </Spin>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  stat: state.missingMedDashReducer,
  userDto: state.authReducer?.AuthData?.userDTO,
  userType: state.authReducer?.userType,
  warehouseList: state.authReducer?.AuthData?.warehouseList,
});

export default withRouter(
  connect(mapStateToProps, { MissingMedDashboardThunk })(MissingMedDashboard)
);
